import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateActivityParticipationStatus } from '../api/activityApi'

/** ACTIVITY_STATUS değerleri (GM kararı / katılım durumu). */
export const PARTICIPATION_STATUS = { WAITING: 350, ATTENDING: 351, NOT_ATTENDING: 352 } as const

/**
 * Etkinlik katılım durumu (GM kararı) güncelleme. Başarıda liste + KPI özeti + yönetici özeti
 * sorgularını tazeler (durum kolonu/rozet ve sayılar güncellensin).
 */
export function useUpdateParticipation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, statusId }: { id: number; statusId: number }) =>
      updateActivityParticipationStatus(id, statusId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['activities'] })
      qc.invalidateQueries({ queryKey: ['activity-summary'] })
      qc.invalidateQueries({ queryKey: ['activity-executive-summary'] })
    },
  })
}
